export default __webpack_public_path__ + "6b2d495c0db1886de405990a03fbc0a2.png";